import * as t from 'io-ts';
import { PaginatedResponse } from './paginated-response.type';
import { RequestForQuotationSupplierLookup } from './request-for-quotation-supplier-lookup.type';

const RequestForQuotationSupplierResponse = t.intersection(
  [
    PaginatedResponse,
    t.type({
      items: t.array(RequestForQuotationSupplierLookup),
    }),
  ],
  'RequestForQuotationSupplierResponse',
);

type RequestForQuotationSupplierResponse = t.TypeOf<
  typeof RequestForQuotationSupplierResponse
>;
export { RequestForQuotationSupplierResponse };
